import Categories from "../Categories";
import GamesFeed from "../GamesFeed";
import { useState } from "react";
import Team from "../Team";
import TeamDashboard from "../TeamDashboard";
import "./Overview.css";

const Overview = ({ setTab }) => {
  const [categories] = useState([
    {
      id: 1,
      category: "Adventure",
      icon: "https://gist.githubusercontent.com/faustabmnyh/62245f19337b13c5195999e7acbb525d/raw/0c556a08d11ebb7c5d5f32dc1338d7cf50739d92/icon-adventure.svg",
    },
    {
      id: 2,
      category: "Puzzle",
      icon: "https://gist.githubusercontent.com/faustabmnyh/62245f19337b13c5195999e7acbb525d/raw/a69709cf7ba3b2b9db83ed597775e16a2d62818b/icon-puzzle.svg",
    },
    {
      id: 3,
      category: "Arcade",
      icon: "https://gist.githubusercontent.com/faustabmnyh/62245f19337b13c5195999e7acbb525d/raw/a69709cf7ba3b2b9db83ed597775e16a2d62818b/icon-arcade.svg",
    },
    {
      id: 4,
      category: "AR Games",
      icon: "https://gist.githubusercontent.com/faustabmnyh/62245f19337b13c5195999e7acbb525d/raw/a69709cf7ba3b2b9db83ed597775e16a2d62818b/icon-ar.svg",
    },
    {
      id: 5,
      category: "Strategy",
      icon: "https://gist.githubusercontent.com/faustabmnyh/62245f19337b13c5195999e7acbb525d/raw/0c556a08d11ebb7c5d5f32dc1338d7cf50739d92/icon-strategy.svg",
    },
  ]);
  return (
    <div className="overview">
      <TeamDashboard setTab={setTab} />
      <Team />
      <Categories
        getCategories={[
          {
            id: 0,
            default: true,
            category: "All",
            icon: "https://gist.githubusercontent.com/faustabmnyh/62245f19337b13c5195999e7acbb525d/raw/426aa188217db7bb6ee29426086bd5fd92c528bf/icon-all.svg",
          },
          ...categories,
        ]}
        center
        relative
        type="game"
      />
      <GamesFeed />
    </div>
  );
};

export default Overview;
